import { Contract, type JsonRpcProvider } from 'ethers'
import { getSafeInterface } from './safe-interface'

/**
 * Get an ethers Contract instance using JsonRpcProvider
 * Uses a read-only provider for contract queries
 */
const getSafeContract = (provider: JsonRpcProvider, safeAddress: string): Contract => {
  const safeInterface = getSafeInterface()
  return new Contract(safeAddress, safeInterface, provider)
}

/**
 * Get Safe threshold by calling the contract through JSON-RPC
 * Uses a read-only provider for Hedera EVM JSON-RPC interface
 */
export const getSafeThresholdFromContract = async (provider: JsonRpcProvider, safeAddress: string): Promise<number> => {
  try {
    const contract = getSafeContract(provider, safeAddress)
    const threshold = await contract.getThreshold()
    return Number(threshold)
  } catch (error) {
    console.error('Error getting threshold from contract:', error)
    throw error
  }
}

/**
 * Check if an owner has approved a hash by calling the contract through JSON-RPC
 * Uses a read-only provider for Hedera EVM JSON-RPC interface
 */
export const checkApprovedHashFromContract = async (
  provider: JsonRpcProvider,
  safeAddress: string,
  ownerAddress: string,
  safeTxHash: string,
): Promise<boolean> => {
  try {
    const contract = getSafeContract(provider, safeAddress)
    const approvalTimestamp = await contract.approvedHashes(ownerAddress, safeTxHash)
    return Number(approvalTimestamp) > 0
  } catch (error) {
    console.error('Error checking approved hash:', error)
    return false
  }
}
